import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AuthLayoutComponent,
    AlertComponent,
    AvatarComponent,
    BaseComponent,
    ButtonComponent,
    ButtonIconComponent,
    CardAccessComponent,
    CardComponent,
    CheckboxComponent,
    ChipsComponent,
    CopyTextComponent,
    CopyTextDirective,
    DetailLayoutComponent,
    DividerComponent,
    EmptyStateComponent,
    FormGroupComponent,
    IconComponent,
    InputComponent,
    LinkComponent,
    ListLayoutComponent,
    ModalComponent,
    NavHelpComponent,
    ProcessComponent,
    ProgressComponent,
    PwcsLayoutComponent,
    ScanComponent,
    ScanFaceComponent,
    SelectComponent,
    SnackbarComponent,
    SpinnerComponent,
    StatsComponent,
    StepperMicroComponent,
    SwitchComponent,
    TableComponent,
    TagComponent,
    TagIconComponent,
    TileComponent,
    TitleGroupComponent,
    TooltipComponent,
    TopnavComponent,
    UploadComponent,
    WatermarkComponent,
} from '@tecalisdev/infinity';


@NgModule({
    declarations: [],
    imports: [
        AuthLayoutComponent,
        AlertComponent,
        AvatarComponent,
        BaseComponent,
        ButtonComponent,
        ButtonIconComponent,
        CardAccessComponent,
        CardComponent,
        CheckboxComponent,
        ChipsComponent,
        CopyTextComponent,
        CopyTextDirective,
        DetailLayoutComponent,
        DividerComponent,
        EmptyStateComponent,
        FormGroupComponent,
        IconComponent,
        InputComponent,
        LinkComponent,
        ListLayoutComponent,
        ModalComponent,
        NavHelpComponent,
        ProcessComponent,
        ProgressComponent,
        PwcsLayoutComponent,
        ScanComponent,
        ScanFaceComponent,
        SelectComponent,
        SnackbarComponent,
        SpinnerComponent,
        StatsComponent,
        StepperMicroComponent,
        SwitchComponent,
        TableComponent,
        TagComponent,
        TagIconComponent,
        TileComponent,
        TitleGroupComponent,
        TooltipComponent,
        TopnavComponent,
        UploadComponent,
        WatermarkComponent,
    ],
    exports: [
        AuthLayoutComponent,
        AlertComponent,
        AvatarComponent,
        BaseComponent,
        ButtonComponent,
        ButtonIconComponent,
        CardAccessComponent,
        CardComponent,
        CheckboxComponent,
        ChipsComponent,
        CopyTextComponent,
        CopyTextDirective,
        DetailLayoutComponent,
        DividerComponent,
        EmptyStateComponent,
        FormGroupComponent,
        IconComponent,
        InputComponent,
        LinkComponent,
        ListLayoutComponent,
        ModalComponent,
        NavHelpComponent,
        ProcessComponent,
        ProgressComponent,
        PwcsLayoutComponent,
        ScanComponent,
        ScanFaceComponent,
        SelectComponent,
        SnackbarComponent,
        SpinnerComponent,
        StatsComponent,
        StepperMicroComponent,
        SwitchComponent,
        TableComponent,
        TagComponent,
        TagIconComponent,
        TileComponent,
        TitleGroupComponent,
        TooltipComponent,
        TopnavComponent,
        UploadComponent,
        WatermarkComponent,
    ],
})
export class InfinityModule { }
